import { createFileRoute } from '@tanstack/react-router';

import { AdminClubsPage } from '@/components/admin/sport/clubs-page';
import { adminHead } from '@/lib/seo';
import { adminListClubsFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/clubs')({
    component: ClubsRoute,
    head: () => adminHead('מועדונים', '/admin/sport/clubs'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListClubsFn({ data: { limit: 50 } }),
});

function ClubsRoute() {
    return <AdminClubsPage initial={Route.useLoaderData()} />;
}
